import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限 - 设备 - 列表
    AUTH_DEVICE() {
      return hasApiMenuPermission('and', ['auth_device', 'auth_device_list']);
    },

    // 权限 - 设备 - 详情
    AUTH_DEVICE_DETAIL() {
      return hasApiMenuPermission('and', ['auth_device_detail']);
    },

    // 权限 - 设备 - 添加
    AUTH_DEVICE_ADD() {
      return hasApiMenuPermission('and', ['auth_device_add']);
    },

    // 权限 - 设备 - 编辑
    AUTH_DEVICE_EDIT() {
      return hasApiMenuPermission('and', ['auth_device_edit']);
    },

    // 权限 - 设备 - 删除
    AUTH_DEVICE_DELETE() {
      return hasApiMenuPermission('and', ['auth_device_delete']);
    },

    // 权限 - 设备 - 维护
    AUTH_DEVICE_MAINTENANCE() {
      return hasApiMenuPermission('and', ['auth_device_maintenance']);
    },

    // 权限 - 设备 - 启用禁用
    AUTH_DEVICE_ENABLE_DISABLE() {
      return hasApiMenuPermission('and', ['auth_device_enable_disable']);
    },

    // 权限 - 设备 - 导出
    AUTH_DEVICE_EXPORT() {
      return hasApiMenuPermission('and', ['auth_device_list']);
    },

    // 权限 - 设备 - 详情 - WEBUI
    AUTH_DEVICE_WEBUI_CONNECT() {
      return hasApiMenuPermission('and', [
        'auth_device_webui_connect',
        'auth_device_vpn_start',
        'auth_device_vpn_status',
        'auth_device_webui_connect',
        'auth_device_webui_status',
      ]);
    },

    // 权限 - 设备 - 详情 - WEBUI - 断开
    AUTH_DEVICE_WEBUI_DISCONNECT() {
      return hasApiMenuPermission('and', ['auth_device_webui_disconnect']);
    },

    // 权限 - 设备 - 详情 - SSH
    AUTH_DEVICE_SSH_CONNECT() {
      return hasApiMenuPermission('and', [
        'auth_device_webui_ssh',
        'auth_device_vpn_start',
        'auth_device_vpn_status',
        'auth_device_ssh_connect',
        'auth_device_ssh_status',
      ]);
    },

    // 权限 - 设备 - 详情 - VPN强制下线
    AUTH_DEVICE_VPN_STOP() {
      return hasApiMenuPermission('and', ['auth_device_vpn_stop']);
    },

    // 权限 - 设备 - 详情 - 其他控制操作
    AUTH_DEVICE_CONTROL() {
      return hasApiMenuPermission('and', ['auth_device_ctrl', 'auth_device_ctrl_execs']);
    },

    // 权限 - 设备 - 详情 - 查看设备模型
    AUTH_DEVICE_MODEL() {
      return hasApiMenuPermission('and', ['auth_deviceModel']);
    },

    // 权限 - 设备 - 详情 - 查看运行配置信息
    AUTH_DEVICE_RUNNING_CONFIG() {
      return hasApiMenuPermission('and', ['auth_device_config', 'auth_device_config_list']);
    },

    // 权限 - 设备 - 详情 - 查看参数配置信息
    AUTH_DEVICE_PARAMS_CONFIG() {
      return hasApiMenuPermission('and', ['auth_device_params', 'auth_device_param_list']);
    },

    // 权限 - 设备 - 详情 - 故障列表
    AUTH_DEVICE_FAULT() {
      return hasApiMenuPermission('and', ['auth_device_fault']);
    },

    // 权限 - 设备 - 详情 - 故障列表 - 当前
    AUTH_DEVICE_FAULT_CURRENT() {
      return hasApiMenuPermission('and', ['auth_device_fault_current']);
    },

    // 权限 - 设备 - 详情 - 故障列表 - 历史
    AUTH_DEVICE_FAULT_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_fault_history']);
    },

    // 权限 - 设备 - 详情 - 查看设备日志
    AUTH_DEVICE_LOG() {
      return hasApiMenuPermission('and', ['auth_device_log']);
    },

    // 权限 - 设备 - 详情 - 查看数据图表
    AUTH_DEVICE_CHART() {
      return hasApiMenuPermission('and', ['auth_device_chart']);
    },

    // 权限 - 设备 - 详情 - 获取设备模型类型
    AUTH_DEVICE_MODEL_GROUP() {
      return hasApiMenuPermission('and', ['auth_device_config_params_group']);
    },

    // 权限 - 设备 - 详情 - 批量设置参数
    AUTH_DEVICE_PARAM_SET() {
      return hasApiMenuPermission('and', ['auth_device_param_set']);
    },

    // 权限 - 设备 - 详情 - 批量设置参数
    AUTH_DEVICE_PARAM_SETS() {
      return hasApiMenuPermission('and', ['auth_device_param_sets']);
    },

    // 权限 - 设备 - 详情 - 参数导出
    AUTH_DEVICE_PARAM_EXPORT() {
      return hasApiMenuPermission('and', ['auth_device_param_export']);
    },

    // 权限 - 设备 - 详情 - 参数导入
    AUTH_DEVICE_PARAM_IMPORT() {
      return hasApiMenuPermission('and', ['auth_device_param_import']);
    },

    // 权限 - 设备 - 详情 - 日志 - 操作记录
    AUTH_DEVICE_OPERATOR_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_operator_history']);
    },

    // 权限 - 设备 - 详情 - 日志 - 控制记录
    AUTH_DEVICE_CTRL_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_ctrl_history']);
    },

    // 权限 - 设备 - 详情 - 日志 - 配置事件记录
    AUTH_DEVICE_CFG_EVENT_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_cfg_event_history']);
    },

    // 权限 - 设备 - 详情 - 日志 - 配置变化日志
    AUTH_DEVICE_PARAMS_CHANGE_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_params_change_history']);
    },

    // 权限 - 设备 - 详情 - 日志 - 数据图表（告警和故障统计）
    AUTH_DEVICE_CHART_ALARM_FAULT() {
      return hasApiMenuPermission('and', ['auth_device_chart_alarm_fault']);
    },

    // 权限 - 设备 - 详情 - 日志 - 数据图表（历史流量）
    AUTH_DEVICE_CHART_TRAFFIC_HISTORY() {
      return hasApiMenuPermission('and', ['auth_device_chart_traffic_history']);
    },

    // 权限 - 设备 - 详情 - 日志 - 数据图表（故障排行）
    AUTH_DEVICE_CHART_FAULT_RANKING() {
      return hasApiMenuPermission('and', ['auth_device_chart_fault_ranking']);
    },
  },
};
